// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__QwxC-","bannerText":"Banner_bannerText__xVAuD","nav":"Banner_nav__lx-Ml"};